module.exports = __webpack_public_path__ + "static/img/200247.0774ae03.png";